module.exports = __webpack_public_path__ + "img/thc_token.faded.d8bacd0.png";